import React from 'react'
import { Link } from 'react-router-dom'
import { routesURLs } from '../../../Routes'
import menuIcon from '../../../assets/images/front/svg/menu.svg'
import closeIcon from '../../../assets/images/front/svg/close.svg'
import tikTokIcon from '../../../assets/images/front/svg/tiktok-blue.svg'
import youTubeIcon from '../../../assets/images/front/svg/youtube-blue.svg'
import facebookIcon from '../../../assets/images/front/svg/facebook-blue.svg'
import instagramIcon from '../../../assets/images/front/svg/instagram-blue.svg'
import Basket from '../../Basket/Basket'
import UserDropdown from '../../TheUserDropdown/UserDropdown'
import { getCookie } from '../../../services/utils'

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = React.useState(false)
  const [isLoggedIn, setIsLoggedIn] = React.useState(!!getCookie('jid'))

  React.useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
    return () => {
      document.body.style.overflow = ''
    }
  }, [menuOpen])

  React.useEffect(() => {
    const handleAuthChange = () => setIsLoggedIn(!!getCookie('jid'))
    window.addEventListener('authChange', handleAuthChange)
    return () => window.removeEventListener('authChange', handleAuthChange)
  }, [])

  return (
    <header>
      <div className="w-full flex bg-white shadow-lg absolute top-0 left-0 right-0 z-50">
        <div className="w-full max-w-[1000px] md:h-[88px] flex items-center lg:justify-between mx-auto px-4 py-4 md:py-6">
          <span className="block lg:hidden w-4 h-auto me-2" onClick={() => setMenuOpen(!menuOpen)}>
            <img src={menuIcon} className={`${menuOpen && 'hidden'}`} alt="" />
            <img src={closeIcon} className={`${!menuOpen && 'hidden'}`} alt="" />
          </span>
          {menuOpen && (
            <div className="font-myriad fixed lg:hidden h-[calc(100vh-52px)] top-[52px] left-0 z-50 bg-white p-4 border-r border-b border-[#eee] rounded-br-2xl flex flex-col items-start">
              <ul className="text-[#0183BA] mb-4 is-pure-list">
                <li className="mb-4">
                  <Link to={routesURLs.pkAll} className="hover:underline">
                    <strong>Kurzy</strong>
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.pnAll} className="hover:underline">
                    <strong>Přijímačky nanečisto</strong>
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.onlineSchool} className="hover:underline">
                    <strong>Online škola</strong>
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.privateClass} className="hover:underline">
                    <strong>Doučování</strong>
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.blog} className="hover:underline">
                    <strong>Blog</strong>
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.contact} className="hover:underline">
                    Kontakty
                  </Link>
                </li>
                <li className="mb-4">
                  <Link to={routesURLs.aboutUs} className="hover:underline">
                    O nás
                  </Link>
                </li>
              </ul>
              <Link
                to={routesURLs.signin}
                className="cursor-pointer flex items-center justify-center text-white w-[185px] py-2 font-semibold text-base bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl mb-4 transition-colors duration-200"
              >
                <img
                  className="me-2"
                  src="https://c.animaapp.com/mbyttqkuyMhIPB/img/material-symbols-light-person-rounded.svg"
                />
                Osobní zóna
              </Link>
              <div className="flex items-center justify-center gap-3 mx-auto">
                <a href="#">
                  <img className="w-6 h-6" src={tikTokIcon} alt="" />
                </a>
                <a href="#">
                  <img className="w-6 h-6" src={youTubeIcon} alt="" />
                </a>
                <a href="#">
                  <img className="w-6 h-6" src={facebookIcon} alt="" />
                </a>
                <a href="#">
                  <img className="w-6 h-6" src={instagramIcon} alt="" />
                </a>
              </div>
            </div>
          )}
          <Link to={routesURLs.fronthomepage} className="block me-auto lg:me-0 cursor-pointer">
            <img
              className="w-[86px] h-[13px] lg:w-[172px] lg:h-[26px] object-cover"
              src="https://c.animaapp.com/mbyttqkuyMhIPB/img/image-1-1.png"
            />
          </Link>
          <nav className="items-center justify-between gap-8 hidden lg:flex">
            <Link
              to={routesURLs.pkAll}
              className="text-wrapper-25 hover:underline cursor-pointer"
              style={{ color: '#0083b9', fontWeight: 500 }}
            >
              Kurzy
            </Link>
            <Link
              to={routesURLs.pnAll}
              className="text-wrapper-25 hover:underline cursor-pointer"
              style={{ color: '#0083b9', fontWeight: 500 }}
            >
              Přijímačky nanečisto
            </Link>
            <Link
              to={routesURLs.aboutUs}
              className="text-wrapper-25 hover:underline cursor-pointer"
              style={{ color: '#0083b9', fontWeight: 500 }}
            >
              O nás
            </Link>
            <Link
              to={routesURLs.contact}
              className="text-wrapper-25 hover:underline cursor-pointer"
              style={{ color: '#0083b9', fontWeight: 500 }}
            >
              Kontakty
            </Link>
            <Link
              to={routesURLs.blog}
              className="text-wrapper-25 hover:underline cursor-pointer"
              style={{ color: '#0083b9', fontWeight: 500 }}
            >
              Blog
            </Link>
          </nav>
          <div className="flex items-center gap-4">
            {isLoggedIn ? (
              <UserDropdown />
            ) : (
              <Link
                to={routesURLs.signin}
                className="cursor-pointer hidden lg:flex font-myriad items-center justify-center text-white w-[185px] py-2 font-semibold text-base bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl transition-colors duration-200"
              >
                <img
                  className="me-2"
                  src="https://c.animaapp.com/mbyttqkuyMhIPB/img/material-symbols-light-person-rounded.svg"
                />
                Osobní zóna
              </Link>
            )}
            {/*
            <span
              onClick={() => history.push(routesURLs.signin)}
              className="cursor-pointer hidden lg:flex font-myriad items-center justify-center text-white w-[185px] py-2 font-semibold text-base bg-[#A8CD00] hover:bg-[#8FB200] rounded-xl transition-colors duration-200"
            >
              <img
                className="me-2"
                src="https://c.animaapp.com/mbyttqkuyMhIPB/img/material-symbols-light-person-rounded.svg"
              />
              Osobní zóna
            </span>
            */}
            <Basket />
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
